const setupUpdatedFieldsToObject = (object, updatedFields) => {
  updatedFields.forEach((updatedField) => {
    const { propertyName, newValue } = updatedField;

    object[propertyName] = newValue;
  });

  return object;
};

const objectWithoutProperties = (obj, keys) => {
  let target = {};
  for (let i in obj) {
    if (keys.indexOf(i) >= 0) {
      continue;
    }

    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      continue;
    }

    target[i] = obj[i];
  }
  return target;
};

function isObject(object) {
  return object != null && typeof object === "object";
}

const objFilterByKeys = (obj, keys = []) => {
  const filtered = Object.keys(obj)
    .filter((key) => keys.includes(key))
    .reduce((object, key) => {
      object[key] = obj[key];
      return object;
    }, {});

  return filtered;
};

function isDate(object) {
  return object != null && object instanceof Date;
}

const objEquals = (obj1, obj2) => {
  if (obj1 !== null && obj2 !== null && obj1 !== undefined && obj2 !== undefined) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      const areDates = isDate(val1) && isDate(val2);
      const areObjects = isObject(val1) && isObject(val2);

      if (areDates && val1.getTime() !== val2.getTime()) {
        return false;
      }

      if ((areObjects && !objEquals(val1, val2)) || (!areObjects && val1 !== val2)) {
        return false;
      }
    }
    return true;
  }

  if ((obj1 == null && obj2 != null) || (obj2 == null && obj1 != null)) {
    return false;
  }

  return true;
};

const objEqualsExcludeKey = (obj1, obj2, excludedKey) => {
  if (obj1 && obj2) {
    const keys1 = Object.keys(obj1).filter((key) => key !== excludedKey);
    const keys2 = Object.keys(obj2).filter((key) => key !== excludedKey);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if ((areObjects && !objEquals(val1, val2, excludedKey)) || (!areObjects && val1 !== val2)) {
        return false;
      }
    }
    return true;
  }
  return true;
};

const isEmpty = (obj) => {
  return JSON.stringify(obj) === "{}";
};

const filterObject = (obj, filter, filterValue) =>
  Object.keys(obj).reduce(
    (acc, val) =>
      obj[val][filter] === filterValue
        ? acc
        : {
            ...acc,
            [val]: obj[val]
          },
    {}
  );

const getMaxValue = (obj) => {
  return obj && Math.max(...Object.values(obj));
};

const getSum = (obj) => {
  return obj && Object.values(obj).reduce((a, b) => a + b, 0);
};

const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

const isNullOrDefault = (object) => {
  return Object.values(object).every(
    (value) =>
      !value ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" && value !== null && isNullOrDefault(value))
  );
};

const removeEmptyFileds = (object) => {
  return JSON.parse(JSON.stringify(object));
};

const objectUtil = {
  setupUpdatedFieldsToObject,
  objectWithoutProperties,
  objFilterByKeys,
  objEquals,
  objEqualsExcludeKey,
  isEmpty,
  isObject,
  filterObject,
  getMaxValue,
  getSum,
  groupBy,
  isNullOrDefault,
  removeEmptyFileds
};

export default objectUtil;
